module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Regional-Landing-Page-w960.aa599dc6.jpg";